module.exports = __webpack_public_path__ + "static/media/trophy.e3c5cf16.png";